import BlogDetails from "./BlogDetails/BlogDetails";
import RelatedBlogs from "./BlogDetails/RelatedBlogs";
import SEO from "../../components/SEO";

export default function BlogDetail({ currentLanguage = "en" }) {
  // SEO titles based on language
  const pageTitles = {
    en: "Blog",
    fr: "Blogues", // ✅ proper French word
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />

      <BlogDetails currentLanguage={currentLanguage} />
      <RelatedBlogs currentLanguage={currentLanguage} />
    </>
  );
}
